const galleryId = 54;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_548231284a.jpg","sh_1627811692.jpg","sh_1669842103.jpg","sh_548231284_1.jpg","sh_548231284_2.jpg","sh_548231284_3.jpg","sh_548231284_4.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Bridge procedure'));

group = ["sh_1787451704.jpg","sh_1014790549.jpg","sh_1512081779.jpg","sh_112375256.jpg","sh_148407323.jpg","sh_115623823.jpg","sh_116636794.jpg","sh_1078198895.jpg","sh_149558366.jpg"];
group.forEach((i) => addItemToGroup(i, '2. PFM bridge'));

group = ["sh_1645168276.jpg","sh_1182399193.jpg","sh_230426437.jpg","sh_217610149.jpg","sh_230426416.jpg","sh_231049792.jpg","sh_1515099938.jpg","sh_1646434075.jpg","sh_1666088464.jpg","sh_1664052157.jpg"];
group.forEach((i) => addItemToGroup(i, '3. Zirconium bridge'));

group = ["sh_1050054875.jpg","sh_1434062699.jpg","sh_1218120160.jpg","sh_1559070743.jpg","sh_1369131086.jpg","sh_1408362443.jpg","sh_1505970353.jpg","sh_1681902328.jpg","sh_1537207196.jpg","sh_1537207202.jpg","sh_1582203982.jpg","sh_1646434081.jpg","sh_1741122440.jpg","sh_1218120064.jpg","sh_1570562821.jpg","sh_1431586463.jpg","sh_1431586481.jpg","sh_1420776140.jpg","sh_1681902331.jpg"];
group.forEach((i) => addItemToGroup(i, '4. Implant bridge'));

group = ["sh_1539193661.jpg","sh_1582204114.jpg","sh_1727881165.jpg","sh_1062905879.jpg","sh_1475228189.jpg","sh_1475228195.jpg","sh_1056960650.jpg","sh_1647060706.jpg"];
group.forEach((i) => addItemToGroup(i, '5. Maryland bridge'));

group = ["sh_1843173238.jpg","sh_1843173235.jpg","sh_1843168039.jpg","sh_1431586478.jpg","sh_1431586361.jpg","sh_1751364158.jpg","sh_1646434066.jpg","sh_1646434084.jpg"];
group.forEach((i) => addItemToGroup(i, '6. Bridge with artificial gum'));

group = ["sh_1710517921.jpg","sh_1710517918.jpg","sh_1710517927.jpg","sh_1551809390.jpg","sh_1710517843.jpg","sh_726685039.jpg","sh_1115806589.jpg","sh_1181694721.jpg","sh_1464787286.jpg","sh_1626317890.jpg","sh_1626317899.jpg","sh_1626317905.jpg","sh_1626317926.jpg","sh_1710517900.jpg","sh_1710517903.jpg","sh_1817876024.jpg","sh_1626317932.jpg","sh_1799056645.jpg","sh_1799056648.jpg","sh_1626317917.jpg","sh_1710517900.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_1843168030.jpg","sh_1640857411.jpg","sh_1444882376.jpg","sh_1408362293.jpg","sh_1758922706.jpg","sh_1710517906.jpg","sh_97915919.jpg","sh_785116372.jpg","sh_1026733432.jpg","sh_1710517909.jpg","sh_1582204105.jpg","sh_1260385081.jpg","sh_1799056642.jpg","sh_1525493066.jpg","sh_1597912279.jpg","sh_1218120193.jpg","sh_1559070749.jpg","sh_785116066.jpg","sh_1639325683.jpg","sh_132612572.jpg","sh_211851322.jpg","sh_1570562824.jpg","sh_1143853304.jpg","sh_165493604.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
